import {
  NumberAnswer,
  NumberOnImageAnswer,
  SimpleMathAnswer,
  FillInBlankAnswer,
  DragAndDropExample,
} from '../Question/components';
import { SingleSelector, MultiSelector } from '../../components';
import Immutable from 'immutable';
import AnnotatedImageChecklist from '../AnnotatedImageChecklist';
import { ExemplarResponseChecklist } from '../ExemplarResponseChecklist';
import { useState } from 'react';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import PT from 'prop-types';

export const AnsweredQuestion = ({ question, solvedExamQuestion }) => {
  const questionType = question.get('question_type');
  const checklistItems = solvedExamQuestion.getIn([
    'solution',
    'exemplar_response_checklist_items',
  ]);
  const exemplarResponse = solvedExamQuestion.getIn([
    'solution',
    'exemplar_response',
  ]);
  const [checklistReflections, setChecklistReflections] = useState(
    Immutable.List()
  );

  const onChecklistReflection = (itemId, value) => {
    const reflections = checklistReflections.filter(
      (reflection) =>
        reflection.get('exemplar_response_checklist_item') != itemId
    );
    setChecklistReflections(
      reflections.push(
        Immutable.Map({
          exemplar_response_checklist_item: itemId,
          checked: value,
        })
      )
    );
  };

  // multi-choice questions have the correct answer ticked and the interactive component disabled.
  if (questionType === EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE) {
    const correctAnswerId = solvedExamQuestion
      .get('answers')
      .find((a) => a?.get('is_correct'))
      ?.get('id');
    return (
      <SingleSelector
        disabled
        answers={question.get('answers')}
        correctAnswers={[correctAnswerId]}
        selectedAnswerId={correctAnswerId}
      />
    );
  }

  if (questionType === EXAM_QUESTION_TYPES.SELECT_MULTI) {
    const correctAnswerIds = solvedExamQuestion
      .get('answers')
      .filter((a) => a.get('is_correct'))
      .map((a) => a.get('id'));
    return (
      <MultiSelector
        disabled
        isCorrect
        answers={question.get('answers')}
        correctAnswers={correctAnswerIds}
        selectedAnswerIds={correctAnswerIds}
      />
    );
  }

  // Checklist question.
  if (questionType === EXAM_QUESTION_TYPES.TEXT_CHECKLIST) {
    return (
      <div data-test={`answer-${EXAM_QUESTION_TYPES.TEXT_CHECKLIST}`}>
        <ExemplarResponseChecklist
          checklistItems={checklistItems}
          checklistReflections={checklistReflections}
          exemplarResponse={exemplarResponse}
          onChecklistReflection={onChecklistReflection}
          isSaving={false}
        />
      </div>
    );
  }

  // Worked Checklist question.
  if (questionType === EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE) {
    return (
      <div data-test={`answer-${EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE}`}>
        <AnnotatedImageChecklist
          checklistItems={checklistItems}
          checklistReflections={checklistReflections}
          imageUrl={solvedExamQuestion.getIn([
            'solution',
            'annotation_image_url',
          ])}
          checklistImageAnnotations={solvedExamQuestion.getIn(
            ['solution', 'checklist_image_annotations'],
            Immutable.Map()
          )}
          onChecklistReflection={onChecklistReflection}
          isSaving={false}
        />
      </div>
    );
  }
  if (questionType === EXAM_QUESTION_TYPES.NUMBER) {
    return <NumberAnswer question={question} />;
  }
  if (questionType === EXAM_QUESTION_TYPES.NUMBER_ON_IMAGE) {
    return <NumberOnImageAnswer question={question} />;
  }
  if (questionType === EXAM_QUESTION_TYPES.FILL_IN_BLANK) {
    return <FillInBlankAnswer question={question} />;
  }
  if (questionType === EXAM_QUESTION_TYPES.SIMPLE_MATH) {
    return <SimpleMathAnswer question={question} isCorrect />;
  }

  if (questionType === EXAM_QUESTION_TYPES.DRAG_AND_DROP) {
    return <DragAndDropExample question={question} />;
  }
  // TODO: return Illustration
  if (questionType === EXAM_QUESTION_TYPES.ILLUSTRATION) {
    return <div data-test={`answer-${EXAM_QUESTION_TYPES.ILLUSTRATION}`} />;
  }
  // TODO: return Worked Question
  if (questionType === EXAM_QUESTION_TYPES.WORKED) {
    return <div data-test={`answer-${EXAM_QUESTION_TYPES.WORKED}`} />;
  }

  return null;
};

AnsweredQuestion.propTypes = {
  question: PT.object.isRequired, // see src/edrolo/domains/coursePortal/types/Task.ts for more info
  solvedExamQuestion: PT.object.isRequired, // see src/edrolo/domains/coursePortal/types/Task.ts for more info
};
